import { IconPropsType } from '..';

export const UserIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path d="M8.96684 7.25611C9.18272 8.37306 8.31919 9.18434 7.11279 9.36717C5.94766 9.54428 4.04916 9.54428 2.88721 9.36717C1.68081 9.18434 0.817277 8.37306 1.03316 7.25611H1.03633C1.22047 6.30771 2.11257 5.71639 3.20468 5.76781C4.00154 5.80495 4.49045 5.89921 5.05873 5.89921C5.62701 5.89921 6.01433 5.80495 6.80484 5.76781C7.89378 5.71639 8.78906 6.30771 8.97319 7.25611H8.96684ZM4.85237 1.5C5.99846 1.5 6.92548 2.33699 6.92548 3.36538C6.92548 4.39377 5.99846 5.23076 4.85237 5.23076C3.70629 5.23076 2.77927 4.39377 2.77927 3.36538C2.77927 2.33699 3.70629 1.5 4.85237 1.5Z" />
  </svg>
);
